// extracted by mini-css-extract-plugin
export default {"portfolioList":"portfolioList_portfolioList__6d5Fc","active":"portfolioList_active__vX6Pw"};